import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";

import { ActivatedRoute, Router } from "@angular/router";
import { SistemaService } from "@core/services/sistema.service";
import { AuthenticationService } from "app/auth/service";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";

@Component({
	selector: "app-form-sistema",
	templateUrl: "./form-sistema.component.html",
	styleUrls: ["./form-sistema.component.scss"],
})
export class FormSistemaComponent implements OnInit {
	//colunas
	public id_sistema: number;
	public nome: string;
	public status: string;
	public isLoading = false;

	public href;

	public contentHeader: object;
	private routeSub: Subscription;

	constructor(
		private route: ActivatedRoute,
		private sistemaService: SistemaService,
		private _router: Router
	) { }

	ngOnInit() {
		this.href = this.route.url;

		if (this.href.value[1].path == "cadastro") {
			this.contentHeader = {
				headerTitle: "Cadastrar Sistema",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Sistema",
							isLink: false,
						},
						{
							name: "Cadastrar",
							isLink: false,
						},
					],
				},
			};
		}

		if (this.href.value[1].path == "editar") {
			this.routeSub = this.route.params.subscribe((params) => {
				this.sistemaService.getOne(params["id"]).subscribe(
					(res) => {
						this.id_sistema = params["id"];
						this.nome = res.nome;
						this.status = res.status;
					},
					(error) => error
				);
			});

			this.contentHeader = {
				headerTitle: "Editar Sistema",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Sistema",
							isLink: false,
						},
						{
							name: "Editar",
							isLink: false,
						},
					],
				},
			};
		}

		// this.sistemaService.get().subscribe(
		//   (res) => {
		//     (this.rows = res), (this.temp = res), (this.tempData = this.rows);
		//   },
		//   (error) => error
		// );
	}

	public submitForm(data: NgForm) {
		if (data.form.valid === true) {
			if (this.href.value[1].path == "cadastro") {
				this.isLoading = true;
				this.sistemaService.post(data).subscribe(
					(res) => {
						this.isLoading = false;
						Swal.fire({
							title: "Sucesso!",
							text: "O item foi cadastrado.",
							icon: "success",
							confirmButtonText: "Confirmar",
						}).then((result) => {
							if (result.isConfirmed) {
								// location.href = "/sistema";
								this._router.navigate(['sistema'])
							}
						});
					},
					(error) => {
						this.isLoading = false;
						Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
					}
				);
			}

			if (this.href.value[1].path == "editar") {
				this.isLoading = true;
				this.sistemaService.put(data, this.id_sistema).subscribe(
					(res) => {
						this.isLoading = false;
						Swal.fire({
							title: "Sucesso!",
							text: "O item foi atualizado.",
							icon: "success",
							confirmButtonText: "Confirmar",
						}).then((result) => {
							if (result.isConfirmed) {
								// location.href = "/sistema";
								this._router.navigate(['sistema'])
							}
						});
					},
					(error) => {
						this.isLoading = false;
						Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
					}
				);
			}
		}
	}

	// ngOnDestroy() {
	//   this.routeSub.unsubscribe();
	// }
}

function reformatDate(dateStr) {
	let dArr = dateStr.split("-");
	return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(2);
}
